/* Safari compatibility floor: the bundle parses on ES2020 (Safari 13.1+), but a few runtime
   APIs used by dependencies and our code only exist in Safari 15.4+ — polyfill them before
   anything else executes so older Safari/WebKit boots instead of showing a blank page. */
if (typeof Object.hasOwn !== "function") {
  Object.hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
}
if (typeof globalThis.structuredClone !== "function") {
  globalThis.structuredClone = (v) => (v === undefined ? v : JSON.parse(JSON.stringify(v)));
}
if (typeof crypto !== "undefined" && typeof crypto.randomUUID !== "function") {
  crypto.randomUUID = () =>
    "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
}
